function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 46.5903,
  width: 60.5104,
  height: 60.5104,
  transform: "rotate(-50.35 0 46.5903)",
  fill: "#FFB200"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M79.8687 43.3784C79.8687 43.3784 75.9436 47.123 76.8053 48.0797C77.667 49.0365 84.1772 48.0797 84.1772 48.0797C84.1772 48.0797 84.5589 49.8031 87.2407 49.7081C89.9224 49.613 95.3793 49.7081 95.3793 49.7081",
  fill: "#CCF8FE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.4013 44.3303L65.8422 59.0425C65.8422 59.0425 70.1507 81.5353 73.7416 86.018C77.3325 90.5007 95.5707 104.137 95.5707 104.137L112.66 123.095L139.373 109.618L126.448 94.2231C126.448 94.2231 129.381 66.4477 127.514 61.1951C126.155 57.3729 110.136 43.3862 99.9108 33.8283C95.8743 30.0578 90.3572 28.3004 84.8834 29.0415L55.3418 33.0348C54.7992 33.1084 54.3553 33.5034 54.219 34.0337C54.0826 34.5641 54.2811 35.1242 54.7209 35.4504L57.9444 37.8359L84.0804 38.0259L100.101 65.5654L84.4637 65.3135C84.4637 65.3135 67.8919 35.9446 51.5307 40.0075C50.6296 40.2355 49.9238 40.9358 49.6888 41.8352C49.4539 42.7346 49.7269 43.6906 50.4013 44.3303Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M112.014 57.3747C112.014 57.3747 95.9369 33.7224 92.742 30.9504C90.3533 28.877 87.2407 28.877 87.2407 28.877",
  stroke: "black",
  strokeWidth: 0.55
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M120.153 55.6195C120.153 55.6195 104.028 38.8386 97.809 32.7845C94.9578 30.0078 92.3901 29.5801 92.3901 29.5801",
  stroke: "black",
  strokeWidth: 0.55
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M126.004 49.2549L51.1508 45.9285L41.604 40.2388L51.984 36.7334L126.413 40.044C127.636 40.0961 128.789 40.6331 129.615 41.5363C130.442 42.4394 130.875 43.6345 130.82 44.8577C130.766 46.08 130.228 47.2306 129.324 48.0556C128.421 48.8805 127.226 49.3121 126.004 49.2549Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M69.7406 46.9077L52.1234 46.1252L50.4016 44.4858C49.7283 43.8451 49.4564 42.8891 49.6916 41.99C49.9267 41.0909 50.6318 40.3905 51.5326 40.1614C57.8987 38.5806 64.2917 42.0638 69.7406 46.9077Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M126.376 46.7539C127.579 46.7539 128.554 45.7788 128.554 44.5759C128.554 43.3731 127.579 42.3979 126.376 42.3979C125.173 42.3979 124.198 43.3731 124.198 44.5759C124.198 45.7788 125.173 46.7539 126.376 46.7539Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.9072 32.9523C55.9072 32.9523 59.8276 36.8537 62.2131 32.1001L55.9072 32.9523Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M51.7778 45.637C51.7778 45.637 51.1442 42.7446 55.2199 43.1866C59.2955 43.6285 59.8626 46.8836 58.3879 47.9845C57.4589 48.6468 56.3277 48.9639 55.1898 48.881",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3599 50.8991C19.3599 50.8991 22.8066 24.5271 27.8802 23.8571C32.9538 23.187 33.4337 47.1229 35.6418 47.362C37.8499 47.6012 41.604 40.2388 41.604 40.2388",
  stroke: "black",
  strokeWidth: 3.0096
});

var Svg3 = function Svg3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 124,
    viewBox: "0 0 140 124",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3.b49346a5.svg";
export { ForwardRef as ReactComponent };